import AvatarEditor from 'react-avatar-editor';
import { Button, DialogActions, DialogContent, DialogTitle, Divider, Grid, InputLabel, Slider, Stack, Tooltip } from '@mui/material';
import { useRef, useState } from 'react';
import IconButton from '../../../components/@extended/IconButton';
import { StopOutlined } from '@ant-design/icons';

export interface Props {
  sourceImage: string | File;
  onCancel: () => void;
  onClose: () => void;
  onSave: (image: any) => void;
}

const ProfileAvatarEditor = ({ sourceImage, onCancel, onSave, onClose }: Props) => {
  const editor = useRef<AvatarEditor>(null);
  const [scale, setScale] = useState<number>(1);
  const onApply = () => {
    onSave(editor.current?.getImage());
  };

  return (
    <>
      <DialogTitle>Avatar Adjustment</DialogTitle>
      <Divider />
      <DialogContent sx={{ p: 2.5, textAlign: 'center' }}>
        <AvatarEditor
          ref={editor}
          image={sourceImage}
          width={500}
          height={500}
          border={0}
          borderRadius={360}
          color={[255, 255, 255, 0.6]}
          scale={scale}
          rotate={0}
          disableBoundaryChecks={false}
        />
        <Stack spacing={1} alignItems="center">
          <InputLabel htmlFor="entity-size">Zoom</InputLabel>
          <Slider
            id="entity-size"
            key="entity-size"
            defaultValue={1}
            min={0.1}
            step={0.01}
            max={2}
            aria-label="Default"
            valueLabelDisplay="auto"
            onChange={(event, value) => {
              setScale(Array.isArray(value) ? value[0] : value);
            }}
            sx={{ width: 500 }}
          />
        </Stack>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ p: 1 }}>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <Tooltip title="Cancel" placement="top">
              <IconButton onClick={onCancel} size="large" color="error">
                <StopOutlined />
              </IconButton>
            </Tooltip>
          </Grid>
          <Grid item>
            <Stack direction="row" spacing={2} alignItems="center">
              <Button color="error" onClick={onClose}>
                Use Original Image
              </Button>
              <Button variant="contained" onClick={onApply}>
                Apply Changes
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </DialogActions>
    </>
  );
};

export default ProfileAvatarEditor;
